export const initSearch = (header) => {
  const button = header.querySelector(".menu-search");
  const search = header.querySelector("#search");
  const close = header.querySelector(".close-search");

  if (!button || !search || !close) return;

  // Prevent fade out transition on page load.
  search.classList.remove("hide-on-load");

  const toggleSearchFormVisibility = (show) => {
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    window.location.hash = show ? "search" : "";
    document.documentElement.classList.toggle("no-scroll", show);
    document.body.style.setProperty("margin-top", show ? `-${top}px` : "");
    search.classList.toggle("hide", !show);

    // Focus search input field after a 50ms timeout, otherwise it won't focus.
    if (show) setTimeout(() => document.querySelector('.search-form input[type="search"]')?.focus(), 50);
  };

  if (window.location.hash === "#search") toggleSearchFormVisibility(true);
  button.addEventListener("click", () => toggleSearchFormVisibility(true), { passive: true });
  close.addEventListener("click", () => toggleSearchFormVisibility(false), { passive: true });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") toggleSearchFormVisibility(false);
  }, { passive: true });
};
